/* eslint-disable @trello/assets-alongside-implementation */
import regularbusiness from 'resources/images/templates/categories/regular/business.svg';
import regulardesign from 'resources/images/templates/categories/regular/design.svg';
import regulareducation from 'resources/images/templates/categories/regular/education.svg';
import regularengineering from 'resources/images/templates/categories/regular/engineering.svg';
import regularmarketing from 'resources/images/templates/categories/regular/marketing.svg';
import regularoperationshr from 'resources/images/templates/categories/regular/operations-hr.svg';
import regularpersonal from 'resources/images/templates/categories/regular/personal.svg';
import regularproductmanagement from 'resources/images/templates/categories/regular/product-management.svg';
import regularproductivity from 'resources/images/templates/categories/regular/productivity.svg';
import regularprojectmanagement from 'resources/images/templates/categories/regular/project-management.svg';
import regularremotework from 'resources/images/templates/categories/regular/remote-work.svg';
import regularsales from 'resources/images/templates/categories/regular/sales.svg';
import regularsupport from 'resources/images/templates/categories/regular/support.svg';
import regularteammanagement from 'resources/images/templates/categories/regular/team-management.svg';
import smallbusiness from 'resources/images/templates/categories/small/business.svg';
import smalldesign from 'resources/images/templates/categories/small/design.svg';
import smalleducation from 'resources/images/templates/categories/small/education.svg';
import smallengineering from 'resources/images/templates/categories/small/engineering.svg';
import smallmarketing from 'resources/images/templates/categories/small/marketing.svg';
import smalloperationshr from 'resources/images/templates/categories/small/operations-hr.svg';
import smallpersonal from 'resources/images/templates/categories/small/personal.svg';
import smallproductmanagement from 'resources/images/templates/categories/small/product-management.svg';
import smallproductivity from 'resources/images/templates/categories/small/productivity.svg';
import smallprojectmanagement from 'resources/images/templates/categories/small/project-management.svg';
import smallremotework from 'resources/images/templates/categories/small/remote-work.svg';
import smallsales from 'resources/images/templates/categories/small/sales.svg';
import smallsupport from 'resources/images/templates/categories/small/support.svg';
import smallteammanagement from 'resources/images/templates/categories/small/team-management.svg';
import transparentbusiness from 'resources/images/templates/categories/transparent/business.svg';
import transparentdesign from 'resources/images/templates/categories/transparent/design.svg';
import transparenteducation from 'resources/images/templates/categories/transparent/education.svg';
import transparentengineering from 'resources/images/templates/categories/transparent/engineering.svg';
import transparentmarketing from 'resources/images/templates/categories/transparent/marketing.svg';
import transparentoperationshr from 'resources/images/templates/categories/transparent/operations-hr.svg';
import transparentpersonal from 'resources/images/templates/categories/transparent/personal.svg';
import transparentproductmanagement from 'resources/images/templates/categories/transparent/product-management.svg';
import transparentproductivity from 'resources/images/templates/categories/transparent/productivity.svg';
import transparentprojectmanagement from 'resources/images/templates/categories/transparent/project-management.svg';
import transparentremotework from 'resources/images/templates/categories/transparent/remote-work.svg';
import transparentsales from 'resources/images/templates/categories/transparent/sales.svg';
import transparentsupport from 'resources/images/templates/categories/transparent/support.svg';
import transparentteammanagement from 'resources/images/templates/categories/transparent/team-management.svg';

/**
 * Allowlisted template category image paths, defined as existing assets in
 * `resources/images/template/categories/`.
 *
 * Ideally these would line up with all template categories and be typed
 * throughout, but `category` is commonly just typed as `string` today.
 */
export type TemplateCategoryImagePath =
  | 'business'
  | 'design'
  | 'education'
  | 'engineering'
  | 'marketing'
  | 'operations-hr'
  | 'personal'
  | 'product-management'
  | 'productivity'
  | 'project-management'
  | 'remote-work'
  | 'sales'
  | 'support'
  | 'team-management';

/**
 * Explicitly returns a template category image given a type and image path.
 * This syntax is intentionally redundant in order to identify image usage.
 */
export const getTemplateCategoryImage = (
  image: TemplateCategoryImagePath,
  type: 'regular' | 'small' | 'transparent' = 'regular',
): string => {
  switch (type) {
    case 'regular': {
      switch (image) {
        case 'business':
          return regularbusiness;
        case 'design':
          return regulardesign;
        case 'education':
          return regulareducation;
        case 'engineering':
          return regularengineering;
        case 'marketing':
          return regularmarketing;
        case 'operations-hr':
          return regularoperationshr;
        case 'personal':
          return regularpersonal;
        case 'product-management':
          return regularproductmanagement;
        case 'productivity':
          return regularproductivity;
        case 'project-management':
          return regularprojectmanagement;
        case 'remote-work':
          return regularremotework;
        case 'sales':
          return regularsales;
        case 'support':
          return regularsupport;
        case 'team-management':
          return regularteammanagement;
        default:
          return '';
      }
    }

    case 'small': {
      switch (image) {
        case 'business':
          return smallbusiness;
        case 'design':
          return smalldesign;
        case 'education':
          return smalleducation;
        case 'engineering':
          return smallengineering;
        case 'marketing':
          return smallmarketing;
        case 'operations-hr':
          return smalloperationshr;
        case 'personal':
          return smallpersonal;
        case 'product-management':
          return smallproductmanagement;
        case 'productivity':
          return smallproductivity;
        case 'project-management':
          return smallprojectmanagement;
        case 'remote-work':
          return smallremotework;
        case 'sales':
          return smallsales;
        case 'support':
          return smallsupport;
        case 'team-management':
          return smallteammanagement;
        default:
          return '';
      }
    }

    case 'transparent': {
      switch (image) {
        case 'business':
          return transparentbusiness;
        case 'design':
          return transparentdesign;
        case 'education':
          return transparenteducation;
        case 'engineering':
          return transparentengineering;
        case 'marketing':
          return transparentmarketing;
        case 'operations-hr':
          return transparentoperationshr;
        case 'personal':
          return transparentpersonal;
        case 'product-management':
          return transparentproductmanagement;
        case 'productivity':
          return transparentproductivity;
        case 'project-management':
          return transparentprojectmanagement;
        case 'remote-work':
          return transparentremotework;
        case 'sales':
          return transparentsales;
        case 'support':
          return transparentsupport;
        case 'team-management':
          return transparentteammanagement;
        default:
          return '';
      }
    }

    default:
      return '';
  }
};
